
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.52 15.69c.1 0-.07.13 0 0l.08-.12a.1.1 0 00.07-.12c-.15.24-.07.12-.1 0s.08-.13.17-.15.2-.05.17-.15l1-.24a.33.33 0 01.22.05s-.22-.05-.1 0h.1c.1 0 .12.07.22 0a.1.1 0 01.12.07l.12.08c.1 0 .12.07.22 0a.93.93 0 00.73 0 1.26 1.26 0 00.58-.56.94.94 0 00-.31-1.26A3.61 3.61 0 0025 13.2a3.72 3.72 0 00-2.28 1.6.94.94 0 00.32 1.26 1 1 0 001.38-.24.54.54 0 00.1-.13zM11.81 18.86l.08-.12c.07-.12-.1 0-.08.12l.08-.12c.09 0 .07-.12.17-.14h.09s-.17.15-.09 0 .26-.17.46-.22l.77-.2h-.09.09c.1 0 .12.08.22.05h.1c.1 0-.22-.05-.1 0s.12.08.22.05l.12.08a1.07 1.07 0 001.41-.15c.34-.29.48-.95 0-1.14a3.8 3.8 0 00-2.86-.32 3.92 3.92 0 00-2.3 1.51.81.81 0 00.33 1.11h.05a1.49 1.49 0 001.33-.51z","fill":"#06132f"}}),_c('path',{attrs:{"d":"M30 18.46h-.09c-.09 0-.12-.05-.32 0l-17.42 4.33c-.19.05-1.5.58-1.43.87a9.21 9.21 0 008.61 6.83A11.35 11.35 0 0029.1 25a8.87 8.87 0 00.9-6.54zm-7.79 11.11a8.87 8.87 0 01-9.58-6.27l15.51-3.87c.94 4.2-1.25 9.48-5.93 10.14z","fill":"#ffa000"}}),_c('path',{attrs:{"d":"M35.63 16.66h.11A16.35 16.35 0 0022.45 5a15.58 15.58 0 00-16.6 7.54 15.06 15.06 0 002.76 18.09 17.43 17.43 0 0017.46 3.78 15.33 15.33 0 009.56-17.75zM28.82 31.3c-4.89 3.93-12 4.74-17.07 1a15.05 15.05 0 01-5.47-15.72 15.4 15.4 0 0112-11c7.3-1.37 13.82 3.59 15.64 10.5a15.08 15.08 0 01-5.1 15.22z","fill":"#06132f"}})])
          )
        }
      }
    